export default __webpack_public_path__ + "static/media/logo_embrapii.0ac6e4f7.png";